import zhCn from './locale/zh-cn';
import en from './locale/en';

let defaultLocale = 'zh-cn';
const locales = {};
locales[defaultLocale] = zhCn;
locales.en = en;

export function locale(name, object, isLocal) {
  if (typeof name !== 'string') return locales[defaultLocale];
  let l = defaultLocale;
  if (locales[name]) {
    l = name;
  }
  if (object) {
    locales[name] = object;
    l = name;
  }
  if (!isLocal) {
    defaultLocale = l;
  }
  return locales[name] || locales[defaultLocale];
}

/**
 * get locale object
 * @param {string} name lang
 */
export function getLocale(name) {
  return locale(name, null, true);
}
